/**
 * 弹框信息处理
 */

import { message } from 'antd';

const msg = {
    error(val) {
        message.destroy()
        message.error(val,3)
        console.log(val)
    },
    success(val) {
        message.destroy()
        message.success(val,2)
    },
    warning(val) {
        message.destroy()
        message.warning(val,2)
    },
    info(val){
        message.destroy()
        message.info(val,2)
    }

    
}

export default msg
